<template>
  <div class="thumbnail-preview-wraper">
    <div class="thumbnail-preview-container"  @mouseenter="showMask = true" @mouseleave="showMask = false">
      <el-tooltip  effect="dark" :content="imgData.loading ? '取消上传' : '删除'" placement="bottom" popper-class='img-pre-tooltip' v-if="showMask && !disabled">
        <i class="el-icon-error delete-img" @click="deleteImg"></i>
      </el-tooltip>
      <div class="mask" v-if="showMask && !imgData.loading" @click="previewFile">
        <div class="preview-div"></div>
        <div class="icon-list">
          <el-tooltip  effect="dark" content="外部链接打开" placement="bottom" popper-class='img-pre-tooltip'>
            <div class="link btn link-img" @click.stop="externalLinkPreview">
            </div>
          </el-tooltip>
          <el-tooltip  effect="dark" content="下载" placement="bottom" popper-class='img-pre-tooltip'>
            <div class="download btn download-img" @click.stop="downFile">
            </div>
          </el-tooltip>
          <el-tooltip  effect="dark" content="移动" placement="bottom" popper-class='img-pre-tooltip'>
            <div class="link btn moveImg">
            </div>
          </el-tooltip>
        </div>
      </div>
      <img :src="ossDownloadUrl+imgData.url" alt="" v-if="!imgData.loading">
      <div class='loading-wraper' v-else>
        <i class="el-icon-loading"></i>
        <div class="text">上传中...</div>
      </div>
    </div>
    <div class="edit-name">
      <span @click.stop="!disabled ? isEditName = true : isEditName = false" v-if="!isEditName"><i class="el-icon-edit-outline"></i>&nbsp;{{imgData.name.split('.')[0]}}</span>
      <input v-if="isEditName" type="text"  class="img-edit-input" v-model="imgName" @blur="changeImgName">{{imgData.name.split('.')[1]}}
    </div>
  </div>
</template>

<script>

export default {
  props: ['imgData', 'disabled'],
  data () {
    return {
      isEditName: false,
      imgName: '',
      showMask: false,
      ossDownloadUrl: ''
    }
  },
  created () {
    this.imgName = this.imgData.name.split('.')[0]
    this.ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
  },
  methods: {
    changeImgName () {
      this.isEditName = false
      this.imgData.name = this.imgName + '.' + this.imgData.name.split('.')[1]// 可直接修改filelists
      this.$emit('changeImgName', this.imgData)
    },
    previewFile () {
      this.$emit('previewFile', this.imgData)
    },
    externalLinkPreview () {
      this.$emit('externalLinkPreview', this.imgData)
    },
    downFile () {
      this.$emit('downFile', this.imgData)
    },
    deleteImg () {
      this.$emit('deleteImg', this.imgData)
    }
  }
}
</script>

<style lang='scss' scoped>
.thumbnail-preview-wraper{
  overflow: hidden;
  width: 116px;
  margin-right: 10px;
  margin-bottom: 5px;
  .edit-name{
    color: #333333;
    font-size: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    cursor: pointer;
    text-overflow:ellipsis;
    white-space: nowrap;
    line-height: 20px;
    i{
      font-size: 8px;
      color: #666666;
    }
    .img-edit-input{
      height: 14px;
      width: 80%;
      outline: none;
      padding: 10px 4px;
      font-size: 6px;
    }
  }
}
.thumbnail-preview-container{
  position: relative;
  width: 116px;
  height: 88px;
  background: #EBF5FD;
  border: 1px solid #EBEBEB;
  box-sizing: border-box;
  flex-shrink: 0;
  img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .mask{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: #00000081;
    z-index: 100;
    padding: 0px 5px;
    box-sizing: border-box;
    cursor: pointer;
    .preview-div{
      width: 100%;
      height: 100%;
    }
    .icon-list{
      position: absolute;
      display: flex;
      justify-content: flex-end;
      bottom: 4px;
      right: 5px;
      .btn{
        position: relative;
        width: 14px;
        height: 12px;
        background: #FFFFFF;
        border-radius: 2px;
        color: #737373;
        line-height: 12px;
        cursor: pointer;
        margin: 2px;
        i{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
           font-size: 6px;
        }
        &:hover{
          color:#55ACF1;
        }
      }
      .moveImg{
        background: white url("./assets/move.png") no-repeat center;
        &:hover{
          background: white url("./assets/move-active.png") no-repeat center;
        }
      }
      .link-img{
        background: white url("./assets/link-img.png") no-repeat center;
        &:hover{
          background: white url("./assets/link-img-active.png") no-repeat center;
        }
      }
      .download-img{
        background: white url("./assets/download.png") no-repeat center;
        &:hover{
          background: white url("./assets/download-active.png") no-repeat center;
        }
      }
    }
  }
  .delete-img{
    color: #C7C7CB;
    font-size: 12px;
    position: absolute;
    right: -2px;
    top: -2px;
    z-index: 5000;
    margin-right: 0px;
    &:hover{
      color: #FB7575;
    }
  }
  .loading-wraper{
    background: white;
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 20px;
    i{
      font-size: 20px;
    }
    .text{
      font-size: 12px;
      color: #323232;
    }
  }
}

</style>
<style>
.el-tooltip__popper.img-pre-tooltip {
  padding: 4px;
  font-size: 6px;
  margin-right: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/thumbnail-preview.vue